module.exports = __webpack_public_path__ + "img/dd-logo-infiniti.aaffa259.png";